import { InfiniteData } from "@tanstack/react-query";
import { createInfiniteDataTransform } from "~/shared/util/createInfiniteDataTransform";

export function jobsListDataTransform(
  data: InfiniteData<
    {
      items: {
        id: number;
        title: string;
        aggregates?: { highPriority?: number };
      }[];
    },
    number
  >,
) {
  return createInfiniteDataTransform(data, (job) => {
    return {
      ...job,
      name: job.title,
    };
  });
}
